import { queryClient } from 'App';
import Loading from 'pages/components/Loading';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { supabase } from 'supabase/client';

const OAuthCallback = () => {
  const [queryParameters] = useSearchParams();
  const access_token = queryParameters.get('access_token');
  const refresh_token = queryParameters.get('refresh_token');

  const [sessionData, setSessionData] = useState(null);
  const [sessionError, setSessionError] = useState(null);

  useEffect(() => {
    const setSession = async () => {
      try {
        const { data, error } = await supabase.auth.setSession({
          access_token,
          refresh_token
        });
        setSessionData(data);
        setSessionError(error);
      } catch (error) {
        setSessionError(error);
      }
    };

    setSession();
  }, [access_token, refresh_token]);

  useEffect(() => {
    if (sessionError) {
      window.location.href = '/login';
    }
    if (sessionData) {
      queryClient.invalidateQueries({ queryKey: ['userData'] });
      window.location.href = '/classe'; //TODO: fix this implementing navigate
      // navigate('/classe');
    }
  }, [sessionData, sessionError]);

  return <Loading height="150px" />;
};

export default OAuthCallback;
